import authReducer from './slices/authSlice';
import paymentLinkReducer from './slices/paymentLinkSlice';
import quoteReducer from './slices/quoteSlice';
import trackPackageReducer from './slices/trackPackageSlice';

export const reducers = {
  auth: authReducer,
  paymentLink: paymentLinkReducer,
  quote: quoteReducer,
  trackPackage: trackPackageReducer,
};
